
$(function () { /* query ready function */
    /* register custom validators */
    if ($.validator) {

        $.validator.addMethod("phonenumber", function (value, element, params) {
            return this.optional(element) || /\D*([2-9]\d{2})(\D*)([2-9]\d{2})(\D*)(\d{4})\D*/.test(value);
        });

        $.validator.unobtrusive.adapters.add("phonenumber", ["phonenumber"], function (options) {
            options.rules["phonenumber"] = "#" + options.params.phonenumber;
            options.messages["phonenumber"] = options.message;
        });

        $.validator.addMethod("validmedicare", function (value, element, params) {
            value = "" + value; // ensure string

            if (value.trim() === "") {
                /***
                 * So here's the thing. Users can proceed WITHOUT a medicare number, but not
                 * actually apply for services. SOOOO we validate a number if enetered but
                 * let them proceed if they don't enter one at all. See /Register/Child 
                 * js below and controller for more logic on that
                 */
                return true;
            }

            // accept only digits, dashes or spaces
            if (/[^0-9-\s]+/.test(value)) return false;

            // The Luhn Algorithm. It's so pretty.
            var nCheck = 0, nDigit = 0, bEven = false;
            value = value.replace(/\D/g, "");

            for (var n = value.length - 1; n >= 0; n--) {
                var cDigit = value.charAt(n);
                nDigit = parseInt(cDigit, 10);

                if (bEven) {
                    if ((nDigit *= 2) > 9) nDigit -= 9;
                }

                nCheck += nDigit;
                bEven = !bEven;
            }

            return nCheck % 10 === 0;
        });

        $.validator.unobtrusive.adapters.add("validmedicare", ["validmedicare"], function (options) {
            options.rules["validmedicare"] = "#" + options.params.validmedicare;
            options.messages["validmedicare"] = options.message;
        });


        $.validator.addMethod("validnben", function (value, element, params) {
            value = "" + value; // ensure string

            if (value.trim() === "") {
                return true;
            }

            if (value.length != 10) {
                return false;
            }

            // accept only digits
            if (/[^0-9]+/.test(value)) return false;

            return true;

            /*
             *     Don't validate Luhn for NBEN. Old Win-school numbers don't pass.
             * */

            //// The Luhn Algorithm.
            //var nCheck = 0, nDigit = 0, bEven = false;
            //value = value.replace(/\D/g, "");

            //for (var n = value.length - 1; n >= 0; n--) {
            //    var cDigit = value.charAt(n);
            //    nDigit = parseInt(cDigit, 10);

            //    if (bEven) {
            //        if ((nDigit *= 2) > 9) nDigit -= 9;
            //    }

            //    nCheck += nDigit;
            //    bEven = !bEven;
            //}

            //return nCheck % 10 === 0;
        });

        $.validator.unobtrusive.adapters.add("validnben", ["validnben"], function (options) {
            options.rules["validnben"] = "#" + options.params.validnben;
            options.messages["validnben"] = options.message;
        });

        $.validator.addMethod("validdaterange",
            function (value, element, param) {
                var minDate = Date.parse($(element).prop("min"));
                var maxDate = Date.parse($(element).prop("max"));
                var selectedDate = Date.parse(value);
                if (minDate && maxDate && selectedDate) {
                    return (selectedDate >= minDate && selectedDate <= maxDate);
                }
                return true;
            }
        );

        $.validator.unobtrusive.adapters.add("validdaterange", ["validdaterange"],
            function (options) {
                options.rules["validdaterange"] = "#" + options.params.validdaterange; //true;
                options.messages["validdaterange"] = options.message;
            }
        );

        $.validator.addMethod("dateformat", function (value, element, params) {
            if (value == null || value.trim() == "") return true;
            if (value.length != 10) return false;
            //return /\d\d\d\d[-]\d[\d]?[-]\d[\d]?/.test(value);
            return /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/.test(value);
        });

        $.validator.unobtrusive.adapters.add("dateformat", ["dateformat"], function (options) {
            options.rules["dateformat"] = "#" + options.params.dateformat;
            options.messages["dateformat"] = options.message;
        });
    }

    /* end custom validators */

});